import { css } from '@emotion/core';
import { Css, ITheme } from '../../../ui';

export const ArrowLinkStyles = (theme: ITheme) => css`
	display: flex;
	font-size: ${Css.pxToRem(16)};
	font-weight: 700;
	gap: ${theme.button?.iconSeparator};
	padding: ${Css.pxToRem(10)};
	border-radius: ${theme.button.radius};
	align-items: center;
	color: ${theme.button?.textButton.font.color};
	height: min-content;

	svg {
		path {
			fill: currentColor;
		}
		flex-shrink: 0;
		flex-grow: 0;
	}

	&:hover {
		color: ${theme.button?.textButton.hover.font.color};
	}
`;
